import React from 'react';
import Button from '@material-ui/core/Button';

function GetKund(props) {
    return (
        <div>
            <Button 
            variant="contained"
            disabled={props.isDisabeled}
            onClick={props.getThisKundByOrgnr}
            color="primary">
              Hämta
            </Button>
        </div>
    );
}

export default GetKund;